// Styles
import { makeStyles, tokens } from "@fluentui/react-components";
import { flexChildSizeFlexible, flexParent } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * Styles for RosterSettingsForm component
 */ export const useStyles = makeStyles({
    root: {
        ...flexParent("column", "nowrap"),
        width: "100%",
        height: "100%"
    },
    rosterSettingsFormSection: {
        ...flexChildSizeFlexible(),
        ...flexParent("column", "nowrap")
    },
    rosterSettingsFormContent: {
        ...flexChildSizeFlexible(),
        ...flexParent("column", "nowrap"),
        fontSize: tokens.fontSizeBase200
    },
    privacySection: {
        marginTop: tokens.spacingVerticalXXL
    },
    privacyHeader: {
        fontWeight: tokens.fontWeightSemibold,
        marginBottom: tokens.spacingVerticalXS
    },
    rosterSensitivitySection: {
        marginTop: "40px"
    },
    rosterSettingsFormFooterSection: {
        marginTop: tokens.spacingVerticalL
    }
});
